var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { transformProps, } from "@unpic/core";
let UnpicImg = class UnpicImg extends LitElement {
    constructor() {
        super(...arguments);
        this.src = "";
        this.alt = "";
    }
    render() {
        var _a;
        const inputProps = {
            src: this.src,
            width: this.width,
            height: this.height,
            alt: this.alt,
            loading: this.loading,
            decoding: this.decoding,
            role: this.role,
            sizes: this.sizes,
            fetchpriority: this.fetchpriority,
            layout: this.layout,
        };
        const transformedProps = transformProps(inputProps);
        return html `
      <img
        part="image"
        src="${transformedProps.src}"
        alt="${transformedProps.alt}"
        width="${transformedProps.width}"
        height="${transformedProps.height}"
        style="${styleMap((_a = transformedProps.style) !== null && _a !== void 0 ? _a : {})}"
        srcset="${transformedProps.srcset}"
        role="${ifDefined(transformedProps.role)}"
        sizes="${transformedProps.sizes}"
        loading="${transformedProps.loading}"
        fetchpriority="${ifDefined(transformedProps.fetchpriority)}"
        decoding="${ifDefined(transformedProps.decoding)}"
        crossorigin="${ifDefined(this.crossOrigin)}"
        ismap="${ifDefined(this.isMap)}"
        name="${ifDefined(this.name)}"
        referrerpolicy="${ifDefined(this.referrerPolicy)}"
        usemap="${ifDefined(this.useMap)}"
        @error="${(event) => this.dispatchEvent(new ErrorEvent(event.type, event))}"
        @load="${(event) => this.dispatchEvent(new Event(event.type, event))}"
        @abort="${(event) => this.dispatchEvent(new Event(event.type, event))}"
      />
    `;
    }
};
__decorate([
    property({ type: String })
], UnpicImg.prototype, "src", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "alt", void 0);
__decorate([
    property({ type: Number })
], UnpicImg.prototype, "height", void 0);
__decorate([
    property({ type: Number })
], UnpicImg.prototype, "width", void 0);
__decorate([
    property({ type: Boolean })
], UnpicImg.prototype, "priority", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "fetchpriority", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "loading", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "decoding", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "background", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "objectFit", void 0);
__decorate([
    property({ type: Number })
], UnpicImg.prototype, "aspectRatio", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "layout", void 0);
__decorate([
    property({ type: Array })
], UnpicImg.prototype, "breakpoints", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "cdn", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "crossOrigin", void 0);
__decorate([
    property({ type: Boolean })
], UnpicImg.prototype, "isMap", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "name", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "referrerPolicy", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "sizes", void 0);
__decorate([
    property({ type: String })
], UnpicImg.prototype, "useMap", void 0);
UnpicImg = __decorate([
    customElement("unpic-img")
], UnpicImg);
export { UnpicImg };
//# sourceMappingURL=unpic-img.js.map